import { TContractorFormSource } from "@app/types/insider";

export const CONST_IDB_VERSION = 74;
export const PERSISTOR_NAME = "m.sfx.persistor";
export const GRID_LAYOUTS = {
  "0": "29.5cm" as React.CSSProperties["width"],
  "1": `${29.5 * 1.61803}cm` as React.CSSProperties["width"],
  "2": "100%" as React.CSSProperties["width"],
}; //
export const CONST_RED_ALERT = "%REDALERTALERT%";
export const JUST_IN_BROWSER = process.env.REACT_APP_MODE === "REACT";

export const Central_TaburiMain_Panorama = "Panoramic";
export const CONST_PAGE_LISTS = "lists" as const;
export const CONST_PAGE_SPV = "spv" as const;
export const CONST_FETCH_CANCELED = "FETCH_CANCELED" as const;
export const CONST_QUEUE_REQUEST = "QUEUE_REQUEST" as const;
// SYNCHRONIZATION PREFIXES
export const CONST_PREFIX_FROM_JS = "@FROM_JS::";
export const CONST_PREFIX_FROM_PAS = "@FROM_PAS::";

export const DRAWER_PAGES = {
  DOWNLOAD: "download",
  PROFILE: "profile",
  SWSADMIN: "swsadmin",
  SHOWCASE: "showcase",
  INSIDERS: "insiders",
  SWSADMIN_USERS: "swsadmin/users",
  SWSADMIN_GROUPS: "swsadmin/groups",
  SWSADMIN_SHOWCASE: "swsadmin/showcase",
  APP_HEADER: "appHeader",
  SWSADMIN_EXRATES: "swsadmin/exchange",
  SWSBUILDER: "swsbuilder",
  WHATSNEW: "whatsnew",
  
} as const;

export const SIZES = {
  headerHeight: 61,
  jgHeaderHeight: 24,
  footerHeight: 30,
  drawerWidth: 144,
  headerButtonSize: 110,
  treeSwitchHeight: 65,
  treeSwitchHeightLarge: 98,
};

export const PROFILE_PAGES = {
  WHOAMI: "whoami",
  DISTRIBUTION: "distribution",
  USERS: "distro/users",
  SETTINGS: "distro/settings",
  FILES: "distro/files",
  LICENSE: "distro/license",
} as const;

export const USERS_PAGES = {
  COMMAND: "command",
  USER: "user",
} as const;

export const GROUPS_PAGES = {
  COMMAND: "su-command",
  GROUP: "su-group",
  ENVIRONMENT: "su-group/environment", //the current setup (actions)
  DIRINFO: "su-group/dirinfo", //the dir structure (objects)
  BUILDER: "su-group/builder", // builder integration page
  KEYMEMBERS: "su-group/keymembers", //users and groups
  LICENCE: "su-group/licence", //users and groups
} as const;
/* 

  ROOT: "root",
  SUPER: "super",
  SUDO: "sudo",
  SUPA: "supa",
  ADMINOFADMIN: "adminofadmin",
  SOFTWIZONLY: "softwizonly",
  ADMIN: "admin",
  CORE: "core",
  KERNEL: "kernel",
  ENGINE: "engine",
*/

/*  important! -- THIS IS A COPY FROM KARMA / CONSTANTS.TS
avoid to change this values, 
IF YOU HAVE TO, THEN CHANGE IN DATABASE ACCORDINGLY:
TABLE: "KARMA_LIST_REPORTS " COLUMN: "GROUP_DISPLAY_NAME"
*/
export const CONST_LSTGRP_IMPLICIT = "IMPLICIT" as const;
export const CONST_LSTGRP_SELECTIE = "CRITERIU" as const;
export const CONST_LSTGRP_FAVORITE = "FAVORITE" as const;
export const CONST_LSTGRP_USER = "USER" as const;
export const CONST_LSTGRP_ISTORIC = "ISTORIC" as const;
// DO NOT CHANGE THE KEY NAMES AND ORDER UNLESS YOU KNOW WHAT YOU ARE DOING
// NOTE: FEEL FREE TO CHANGE THE DICTIONARY VALUES //
export const CONST_LSTGRP_DICTIONARY = {
  [CONST_LSTGRP_IMPLICIT]: "Implicit", // ANY STRING ON SCREEN...
  [CONST_LSTGRP_SELECTIE]: "Criterii de selectie",
  [CONST_LSTGRP_FAVORITE]: "Favorite",
  [CONST_LSTGRP_USER]: "Personalizate",
  [CONST_LSTGRP_ISTORIC]: "Istoric",
} as const;
Object.freeze(CONST_LSTGRP_DICTIONARY);

//'PERIOD_PICKER' | 'YEAR_PICKER' |'STARTING_WITH' | 'CURRENCY_PICKER';
export const ParamDefinitionValues = {
  //PERIOD_PICKER
  full_month_of_max_one_year: "full_month_of_max_one_year",
  start_date_and_end_date: "start_date_and_end_date",
} as const;

export enum ModalResult {
  mrNone = 0, // None. Used as a default value before the user exits.
  mrOk, // The user exited with OK button.
  idOK = mrOk, // Alias for mrOk
  mrCancel, // The user exited with the CANCEL button.
  idCancel = mrCancel, // Alias for mrCancel
  mrAbort, // The user exited with the ABORT button.
  idAbort = mrAbort, // Alias for mrAbort
  mrRetry, // The user exited with the RETRY button.
  idRetry = mrRetry, // Alias for mrRetry
  mrIgnore, // The user exited with the IGNORE button.
  idIgnore = mrIgnore, // Alias for mrIgnore
  mrYes, // The user exited with the YES button.
  idYes = mrYes, // Alias for mrYes
  mrNo, // The user exited with the NO button.
  idNo = mrNo, // Alias for mrNo
  mrAll = mrNo + 1, // The user exited with the ALL button.
  mrNoToAll = mrAll + 1, // The user exited with the NO TO ALL button.
  mrYesToAll = mrNoToAll + 1, // The user exited with the YES TO ALL button.
  mrClose = mrYesToAll + 1, // The user exited with the CLOSE button.
}

export const modalButtonCaptions: { [key in ModalResult]: string } = {
  [ModalResult.mrNone]: "",
  [ModalResult.mrOk]: "OK",
  [ModalResult.mrCancel]: "Cancel",
  [ModalResult.mrAbort]: "Abort",
  [ModalResult.mrRetry]: "Retry",
  [ModalResult.mrIgnore]: "Ignore",
  [ModalResult.mrYes]: "Yes",
  [ModalResult.mrNo]: "No",
  [ModalResult.mrAll]: "All",
  [ModalResult.mrNoToAll]: "No to All",
  [ModalResult.mrYesToAll]: "Yes to All",
  [ModalResult.mrClose]: "Close",
};

// Api names //
export const CONST_listQueryState = "listQueryState" as const;
export const CONST_listUiState = "listUiState" as const;
export const CONST_LIST_OF_CONTACTS = "listOf_contacts" as const;
export const CONST_LIST_OF_PERSONS = "listOf_persons" as const;
export const CONST_LIST_OF_MATTERS = "listOf_matters" as const;
export const CONST_LIST_OF_MYWORK = "listOf_mywork" as const;
export const CONST_LIST_SS_OF_MYWORK = "ss_listOf_mywork" as const;
export const CONST_LIST_SS_OF_AVO = "ss_listOf_avocati" as const;
export const CONST_LIST_SS_OF_CTRDOSARE = "ss_listOf_ctrdosare" as const;
export const CONST_LIST_SS_OF_PROFORMA = "ss_listOf_proforma" as const;
export const CONST_LIST_SS_OF_INVOICE = "ss_listOf_invoice" as const;
export const CONST_LIST_SS_OF_SPV_MESSAGES = "ss_listOf_spv_messages" as const;

export const SPV_RIGHT_TABS = {
  FILE: "FILE",
  CONTRACTOR: "CONTRACTOR",
  OPERATIONS: "OPERATIONS",
  PAYMENTS: "PAYMENTS",
};

const CTR_MIRR_TMP = "CFF_TMP" as TContractorFormSource;
const CTR_MIRR_ANAF = "ANAF" as TContractorFormSource;
const CTR_MIRR_ARCHIVE = "CONTACTE" as TContractorFormSource;
const CTR_MAIN = "CFF_MAIN" as TContractorFormSource;
export const SPV_CONTRACTOR_MIRROR = {
  CTR_MIRR_TMP,
  CTR_MIRR_ANAF,
  CTR_MIRR_ARCHIVE,
  CTR_MAIN,
};

///start constants copied from jgap
export const CONST_CCH_PANORAMIC = 1;
export const CONST_CCH_REPORTS = 2;
export const CONST_CCH_INVOICING = 3;
export const CONST_CCHCH_PROFORMA = 4;
export const CONST_CCHCH_TRACKING = 5;
export const CONST_CCHCH_FISCAL = 6;
//new constants from JKarma
export const CONST_CCH_ENTITIES = 7;
export const CONST_CCH_SETTINGS = 8;

export enum ECChooserPage {
  CONST_CCH_PANORAMIC = 1,
  CONST_CCH_REPORTS = 2,
  CONST_CCH_INVOICING = 3,
  CONST_CCHCH_PROFORMA = 4,
  CONST_CCHCH_TRACKING = 5,
  CONST_CCHCH_FISCAL = 6,
  CONST_CCH_ENTITIES = 7,
  CONST_CCH_SETTINGS = 8,
}

///end constants copied from jgap

// COMMAND BUTTON GROUP INSIDER MAIN =CMD_BGIM
// export const enum EMenuCmdTab {
//   CMD_BGIM_CLIENTS = "CLIENTS",
//   CMD_BGIM_EMITENT = "EMITENT",
//   CMD_BGIM_MESSAGES = "spv", // 'MESSAGES',
//   CMD_BGIM_INVOICE_TRACKING = "INVOICE_TRACKING",
//   CMD_BGIM_INVOICE = "BGM_INVOICE",
//   // CMD_BGIM_SETTINGS = 'SETTINGS',
//   CMD_BGIM_REPORTS = "REPORTS",
//   // settings-invoice series
//   CMD_BGIM_INVOICE_SERIES = "INVOICE_SERIES",
//   // settings -license
//   CMD_BGIM_LICENSE = "LICENSE",
//   // settings - OAuth2
//   CMD_BGIM_OAUTH2 = "OAUTH2",
// }

export const enum EMenuCmdTab {
  CMD_BGIM_CLIENTS = "CLIENTS",
  CMD_BGIM_MESSAGES = "spv", // 'MESSAGES',
  CMD_BGIM_INVOICE_TRACKING = "INVOICE_TRACKING",
  CMD_BGIM_INVOICE = "BGM_INVOICE",
  CMD_BGIM_INVOICE_OVERALL = "INVOICE_OVERALL",
  // CMD_BGIM_SETTINGS = 'SETTINGS',
  CMD_BGIM_REPORTS = "REPORTS",
  CMD_BGIM_LICENSE = "LICENSE", // Cabinet
  CMD_BGIM_OAUTH2 = "OAUTH2",

  CMD_BGIM_EMITENT = "EMITENT",
  CMD_BGIM_USERCONFIG = "USERCONFIG",
  CMD_BGIM_INVOICE_SERIES = "INVOICE_SERIES",
  CMD_BGIM_ACCOUNTS = "ACCOUNTS",
}

export const contractorInEditMode = "ie";
export const contractorInSpvMode = "spv";

//[##findme:1233##indelphiandjavascript] -- on process spv message we have to pass the key of the processed message back to js...
export const KeyMarker = ". ##: ";

export const CONST_LSTORIGIN_CONTACTE = "LIST_CONTACTE_ORIGIN" as const;
export const CONST_LSTORIGIN_PERSOANE = "LIST_PERSOANE_ORIGIN" as const;
export const CONST_LSTORIGIN_CONTPERS_MD =
  "LIST_CONTACTE_PERSOANE_ORIGIN" as const;
export const CONST_LISTORIGIN_WORK = "LIST_WORK_ORIGIN" as const;
export const CONST_LISTORIGIN_AVOCATI = "LIST_AVOCATI_ORIGIN" as const;
export const CONST_LISTORIGIN_CTRDOSARE = "LIST_CTRDOSARE_ORIGIN" as const;
export const CONST_LISTORIGIN_PROFORMA = "LIST_PROFORMA_ORIGIN" as const;
export const CONST_LISTORIGIN_INVOICE = "LIST_INVOICE_ORIGIN" as const;
// [##findme##delphi-javascript##0423##]

export const CONST_LISTORIGIN_DICTIONARY = {
  [CONST_LSTORIGIN_CONTACTE]: "Contacte",
  [CONST_LSTORIGIN_PERSOANE]: "Persoane",
  [CONST_LSTORIGIN_CONTPERS_MD]: "Contacte_Persoane",
  [CONST_LISTORIGIN_WORK]: "Activiati",
  [CONST_LISTORIGIN_AVOCATI]: "Avocati",
  [CONST_LISTORIGIN_CTRDOSARE]: "Contracte_Dosare",
  [CONST_LISTORIGIN_PROFORMA]: "Facturi_Proforma",
  [CONST_LISTORIGIN_INVOICE]: "Facturi_Fiscale",
} as const;

export enum EComponentStack {
  HomePage = "HomePage",
  SpvMessages = "SpvMessages", // MESAJESPV
  InvoiceTracking = "InvoiceTracking", // URMARIREFACTURI
  InvoicingInKarma = "InvoicingInKarma", //FACTURARE
  InvoiceOverall = "InvoiceOverall", //FACTURARE IN PERSONAL KARMA
  nop = "nop",
}

export const key_SET_contractors_cff = "SET/ss_contractors_cff";
export const key_SET_contractors_temp = "SET/ss_contractors_temp";

export const CONST_XAPI_INSIDER_LOGOUT_NAME = "xapi/insider/logout"; // <<< don't change this /// !!! ///
export const CONST_SPVSTATUS_SAVE_SUCC = "/emitter/spvMessageShowSaveSuccess";
export const CONST_SHOW_SPVMSG_POPUP = "/emitter/showSpvMessagePopup";
